<template>
  <v-app>
    <v-main>
      <v-container>
        <v-layout justify-center>
          <v-flex xs12 sm12 md12 lg12 xl12>
            <v-card :loading="loading">
              <v-card-title class="pb-5">
                <!--                <v-btn @click="$router.push('/content')" class="btn-back">-->
                <!--                  <span class="flaticon2-reply icon-lg"></span>-->
                <!--                  بازگشت-->
                <!--                </v-btn>-->
                <!--                <v-spacer/>-->
                <!--                ویرایش محتوا-->
                <!--                <v-spacer/>-->
                <v-btn
                  @click="editContent"
                  class="btn-update"
                  :loading="loading"
                >
                  <v-icon>mdi-update</v-icon>
                  بروز رسانی
                </v-btn>
              </v-card-title>

              <v-card-text>
                <v-row>
                  <v-flex xs12 sm12 md3 lg3 xl3 class="p-2">
                    <v-text-field
                      :rules="rules.title"
                      v-model="title"
                      :error-messages="errors.name"
                      autofocus
                      label="عنوان"
                      required
                      outlined
                      dense
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md3 lg3 xl3 class="p-2">
                    <v-select
                      v-model="service"
                      :rules="rules.service"
                      :items="services"
                      :error-messages="errors.service"
                      item-text="nameLand"
                      item-value="id"
                      label="انتخاب سرویس"
                      outlined
                      dense
                    ></v-select>
                  </v-flex>

                  <v-flex xs12 sm12 md3 lg3 xl3 class="p-2">
                    <v-select
                      v-model="type"
                      :rules="rules.type"
                      :items="types"
                      :error-messages="errors.type"
                      item-text="value"
                      item-value="name"
                      label="نوع محتوا"
                      outlined
                      dense
                    ></v-select>
                  </v-flex>

                  <v-row>
                    <v-card-title>معرفی پروژه:</v-card-title>
                    <v-radio-group row v-model="intro">
                      <v-radio label="بله" value="1"></v-radio>
                      <v-radio label="خیر" value="0"></v-radio>
                    </v-radio-group>
                  </v-row>
                </v-row>

                <v-row>
                  <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                    <v-text-field
                      v-model="link"
                      :error-messages="errors.link"
                      label="پیوند"
                      outlined
                      dense
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                    <v-autocomplete
                      label="انتخاب دسته بندی"
                      dense
                      append-icon="mdi-menu"
                      editable
                      auto-select-first
                      outlined
                      v-model="category_id"
                      :items="categories"
                    />
                  </v-flex>
                  <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                    <v-file-input
                      v-model="picture"
                      label="تصویر محتوا"
                      :error-messages="errors.picture"
                      outlined
                      dense
                      append-icon="mdi-camera"
                    ></v-file-input>
                  </v-flex>
                </v-row>
                <v-row>
                  <v-container fluid>
                    <V8Editor v-if="!loading" v-model="description" />
                  </v-container>
                </v-row>

                <v-row v-if="type == 'tutorial'">
                  <v-text-field
                    v-model="newContent.title"
                    autofocus
                    :error-messages="errors.title"
                    label="عنوان آموزش ادمین"
                    required
                    outlined
                    dense
                  >
                  </v-text-field>
                </v-row>

                <v-row v-if="type == 'tutorial'">
                  <v-container fluid>
                    <label>متن اموزش ادمین</label>
                    <V8Editor
                      v-if="!adminLoading"
                      v-model="newContent.description"
                    />
                  </v-container>
                </v-row>

                <v-row v-if="type == 'tutorial'">
                  <v-container fluid>
                    <label>متن اموزش بخش معرفی نامه</label>
                    <V8Editor v-if="!loading" v-model="features" />
                  </v-container>
                </v-row>

                <v-row v-if="type == 'tutorial'">
                  <v-flex xs12 sm12 md12 lg12 xl12 class="p-2">
                    <v-card elevation="0" color="transparent" class="mb-4">
                      <v-card-title>سوالات متداول</v-card-title>

                      <v-card
                        v-for="(x, i) in value"
                        :key="i"
                        outlined
                        class="mb-4"
                      >
                        <v-card-title>
                          <v-chip outlined color="#009688">
                            سوال {{ i + 1 }}
                          </v-chip>

                          <v-spacer />
                          <v-btn
                            x-small
                            fab
                            elevation="0"
                            color="error"
                            @click="deleteKeyValue(x, i)"
                          >
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </v-card-title>

                        <v-row align="center" class="ma-0 pt-3">
                          <v-col cols="12" lg="12" class="pt-0">
                            <v-text-field
                              label="سوال"
                              v-model="x.question"
                              outlined
                              id="propKey"
                            />
                          </v-col>
                        </v-row>

                        <v-row align="center" class="ma-0 pt-3">
                          <v-col cols="12" lg="12" class="pt-0">
                            <V8Editor v-model="x.answer" />
                          </v-col>
                        </v-row>
                      </v-card>

                      <v-card-actions class="pa-0 my-4">
                        <v-btn block color="accent" @click="newKeyValue">
                          <v-icon>mdi-plus</v-icon>
                          افزودن سوال و پاسخ جدید
                        </v-btn>
                      </v-card-actions>

                      <v-divider />
                    </v-card>
                  </v-flex>
                </v-row>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CKEditorUploadAdapterPlugin from "@/core/plugins/CKEditorUploadFileAdapter";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  props: ["id"],
  data() {
    return {
      type: "",
      privilege_type: null,
      loading: false,
      intro: "0",
      adminLoading: false,
      adminTitle: "",
      features: "",
      adminDescription: "",
      value: [],
      editor: {
        editor: ClassicEditor,
        editorConfig: {
          extraPlugins: [CKEditorUploadAdapterPlugin],
        },
      },
      service: null,
      services: [],
      categories: [],
      category_id: null,
      query: { sort: "id", order: "desc", limit: 100, s: "" },
      rules: {
        title: [(val) => (val || "").length > 0 || "فیلد عنوان الزامی می باشد"],
        services: [(val) => val.length > 0 || "فیلد سرویس الزامی می باشد"],
        type: [
          (val) => (val || "").length > 0 || "فیلد نوع محتوا الزامی می باشد",
        ],
      },
      types: [
        { name: "popup", value: "پاپ اپ" },
        { name: "tutorial", value: "آموزش" },
        { name: "news", value: "اخبار" },
        { name: "banner", value: "بنر" },
      ],
      title: "",
      description: "",
      picture: null,
      link: "",
      sortOrder: null,
      newPrivelegeType: null,
      newContent: {
        id: null,
        title: "",
        description: "",
      },
      errors: [],
    };
  },

  async mounted() {
    // this.keydown('editContent')
    try {
      this.services = await this.getService();
    } catch (error) {
      console.error("Failed to fetch services:", error);
      this.$toast.error("خطا در دریافت سرویس‌ها");
    } finally {
    }
    // this.services = this.getService().data
    this.getContent();
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t(this.$route.meta.title) },
    ]);
    this.getCategories();
  },
  methods: {
    newKeyValue() {
      this.value.push({
        question: "",
        answer: "",
      });
    },
    deleteKeyValue(x, i) {
      if (confirm("سوال و جواب حذف شود ؟")) {
        this.value.splice(this.value.indexOf(i), 1);
      }
    },
    getCategories() {
      this.loading = true;

      this.requestApiGet("category/get-all", { permission: true })
        .then(({ data }) => {
          let category = [];
          for (let i = 0; i < data.length; i++) {
            category.push({
              text:
                data[i].name + " \t" + "( " + data[i].service.nameLand + " )",
              value: data[i].id,
            });
          }
          this.categories = category;
          this.loading = false;
        })
        .catch(({ response }) =>
          console.log("error in get provinces: ", response)
        );
    },
    editContent() {
      if (this.service == null) {
        return this.$toast.error("لطفا سرویس را انتخاب کنید");
      }
      if (this.type == null) {
        return this.$toast.error("لطفا نوع محتوا را انتخاب کنید.");
      }

      let formData = new FormData();
      if (this.type == "tutorial") {
        if (this.newContent.title && this.newContent.description) {
          if (this.newContent.id) {
            formData.append("adminId", this.newContent.id);
          } else {
            formData.append("adminId", 404);
          }

          formData.append("adminTitle", this.newContent.title);
          formData.append("adminDescription", this.newContent.description);
        }
      }

      formData.append("service_id", this.service);
      formData.append("features", this.features);
      formData.append("type", this.type);
      formData.append("title", this.title);
      formData.append("intro", this.intro);
      formData.append("description", this.description);
      if (this.picture !== null) formData.append("picture", this.picture);

      formData.append("link", this.link);

      if (this.category_id) {
        formData.append("category_id", this.category_id);
      }

      if (this.features) {
        formData.append("features", this.features);
      }
      if (this.privilege_type) {
        formData.append("privilege_type", this.privilege_type);
      }
      if (this.value && this.value !== [] && this.value !== null) {
        let questionValue = JSON.stringify(this.value);
        formData.append("commonQuestions", questionValue);
      }

      formData.append("_method", "PUT");
      this.requestApiPost(
        `content/${this.id}`,
        formData,
        this.configurationFile()
      )
        .then((response) => {
          this.$toast.success("محتوا با موفقیت ویرایش شد شد");
          this.goReplace("content");
        })
        .catch((e) => {
          this.errors = e.response.data.errors;
        });
    },
    getContent() {
      this.loading = true;
      this.requestApiGet(`content/${this.id}`)
        .then(({ data }) => {
          this.title = data.title;
          this.description = data.description;
          if (data.intro) this.intro = data.intro.toString();
          else this.intro = "0";
          this.link = data.link;
          this.category_id = data.category_id;
          this.features = data.features;
          this.sortOrder = data.sort_order;
          this.service = data.service_id;
          this.type = data.type;
          this.privilege_type = data.privilege_type;
          this.newPrivelegeType =
            data.privilege_type === "admin" ? "user" : "admin";
          if (data.extras !== null) {
            if (!!data.extras)
              try {
                let ext = JSON.parse(data.extras);
                if (typeof ext === "string") {
                  ext = JSON.parse(ext);
                }

                // if (this.tutorial.id > 253) {
                this.value = ext;
                // }
              } catch (e) {
                console.log(e);
              }
            // if (data.id>253){
            //     this.value=JSON.parse(data.extras)
            // }else{
            //     this.value=JSON.parse(JSON.parse(data.extras))
            // }
          } else this.value = [];
        })
        .finally(() => {
          this.loading = true;

          if (this.type == "tutorial") {
            this.requestApiGet(`requestNewContent`, {
              privilege_type: this.newPrivelegeType,
              category_id: this.category_id,
            })
              .then(({ data }) => {
                this.newContent = data;
                // if (!this.value && data.extras !== null) {
                //     this.value = JSON.parse(data.extras)
                // }
              })
              .finally(() => {
                if (this.privilege_type == "admin") {
                  let tempTitle = this.title;
                  let tempDescription = this.description;
                  this.title = this.newContent.title;
                  this.description = this.newContent.description;
                  this.newContent.title = tempTitle;
                  this.newContent.description = tempDescription;
                  this.loading = false;
                }

                this.loading = false;
              });
          }

          // this.loading = false
        });
    },
  },
  computed: {
    ...mapGetters(["layoutConfig"]),
    // ...mapGetters('ContentIndex', ['contents', 'total', 'loading']),
  },
};
</script>
